import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BackendService } from '@ipg/ngx-frontend-toolset';
import {
  ActiveMoveStatus,
  UnitMovePreviewResponse,
  UnitMoveRequest,
} from '../models/move-unit.models';

@Injectable({ providedIn: 'root' })
export class UnitMoveService {
  private readonly _backend = inject(BackendService);

  getActiveMoveStatus(): Observable<ActiveMoveStatus | null> {
    return this._backend.get<ActiveMoveStatus | null>('/units/move/active');
  }

  getMovePreview(
    unitId: string,
    targetPrevUnitId: string
  ): Observable<UnitMovePreviewResponse> {
    return this._backend.get<UnitMovePreviewResponse>(
      `/units/${unitId}/move/preview`,
      { params: { targetPrevUnitId } }
    );
  }

  moveUnit(unitId: string, body: UnitMoveRequest): Observable<string> {
    return this._backend.post<string>(`/units/${unitId}/move`, body);
  }
}
